export const TestTabs = {
  prac_test: 'Practice Tests',
  mock_exam: 'Mock Exams',
}
